<form [formGroup]="specVerliescompensatieFormGroup">
    <div class="row">
        <div formGroupName="specificatieVerliescompensatie">
            <div formGroupName="opbouw">
                <div>
                    <snelstart-ui-number-form-control formControlName="verrekendVerliesBox1"
                                                      id="verrekendVerliesBox1"
                                                      label="Verrekend verlies Box1"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeCompenserenVerliesBox1DitJaar"
                                                      id="nogTeCompenserenVerliesBox1DitJaar"
                                                      label="Nog te comp. Box1 T"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                </div>
                <div>
                    <snelstart-ui-number-form-control formControlName="verrekendVerliesBox1JaarMinNegen"
                                                      id="verrekendVerliesBox1JaarMinNegen"
                                                      label="Verr. verlies Box1 T-9"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeVerrekenenVerliesBox1JaarMinNegen"
                                                      id="nogTeVerrekenenVerliesBox1JaarMinNegen"
                                                      label="Nog te verr Box1 T-9"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="verrekendVerliesBox1JaarMinAcht"
                                                      id="verrekendVerliesBox1JaarMinAcht"
                                                      label="Verr. verlies Box1 T-8"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeVerrekenenVerliesBox1JaarMinAcht"
                                                      id="nogTeVerrekenenVerliesBox1JaarMinAcht"
                                                      label="Nog te verr Box1 T-8"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="verrekendVerliesBox1JaarMinZeven"
                                                      id="verrekendVerliesBox1JaarMinZeven"
                                                      label="Verr. verlies Box1 T-7"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeVerrekenenVerliesBox1JaarMinZeven"
                                                      id="nogTeVerrekenenVerliesBox1JaarMinZeven"
                                                      label="Nog te verr Box1 T-7"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                </div>
                <div>
                    <snelstart-ui-number-form-control formControlName="verrekendVerliesBox1JaarMinZes"
                                                      id="verrekendVerliesBox1JaarMinZes"
                                                      label="Verr. verlies Box1 T-6"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeVerrekenenVerliesBox1JaarMinZes"
                                                      id="nogTeVerrekenenVerliesBox1JaarMinZes"
                                                      label="Nog te verr Box1 T-6"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="verrekendVerliesBox1JaarMinVijf"
                                                      id="verrekendVerliesBox1JaarMinVijf"
                                                      label="Verr. verlies Box1 T-5"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeVerrekenenVerliesBox1JaarMinVijf"
                                                      id="nogTeVerrekenenVerliesBox1JaarMinVijf"
                                                      label="Nog te verr Box1 T-5"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="verrekendVerliesBox1JaarMinVier"
                                                      id="verrekendVerliesBox1JaarMinVier"
                                                      label="Verr. verlies Box1 T-4"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeVerrekenenVerliesBox1JaarMinVier"
                                                      id="nogTeVerrekenenVerliesBox1JaarMinVier"
                                                      label="Nog te verr Box1 T-4"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                </div>
                <div>
                    <snelstart-ui-number-form-control formControlName="verrekendVerliesBox1JaarMinDrie"
                                                      id="verrekendVerliesBox1JaarMinDrie"
                                                      label="Verr. verlies Box1 T-3"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeVerrekenenVerliesBox1JaarMinDrie"
                                                      id="nogTeVerrekenenVerliesBox1JaarMinDrie"
                                                      label="Nog te verr Box1 T-3"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="verrekendVerliesBox1JaarMinTwee"
                                                      id="verrekendVerliesBox1JaarMinTwee"
                                                      label="Verr. verlies Box1 T-2"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeVerrekenenVerliesBox1JaarMinTwee"
                                                      id="nogTeVerrekenenVerliesBox1JaarMinTwee"
                                                      label="Nog te verr Box1 T-2"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="verrekendVerliesBox1JaarMinEen"
                                                      id="verrekendVerliesBox1JaarMinEen"
                                                      label="Verr. verlies Box1 T-1"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeVerrekenenVerliesBox1JaarMinEen"
                                                      id="nogTeVerrekenenVerliesBox1JaarMinEen"
                                                      label="Nog te verr Box1 T-1"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                </div>
                <div>
                    <snelstart-ui-number-form-control formControlName="verrekendVerliesBox2"
                                                      id="verrekendVerliesBox2"
                                                      label="Verrekend verlies Box2"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeCompenserenVerliesBox2DitJaar"
                                                      id="nogTeCompenserenVerliesBox2DitJaar"
                                                      label="Nog te comp. Box2 T"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                </div>
                <div>
                    <snelstart-ui-number-form-control formControlName="verrekendVerliesBox1JaarMinNegen"
                                                      id="verrekendVerliesBox2JaarMinNegen"
                                                      label="Verr. verlies Box2 T-9"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeVerrekenenVerliesBox2JaarMinNegen"
                                                      id="nogTeVerrekenenVerliesBox2JaarMinNegen"
                                                      label="Nog te verr Box2 T-9"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="verrekendVerliesBox2JaarMinAcht"
                                                      id="verrekendVerliesBox2JaarMinAcht"
                                                      label="Verr. verlies Box2 T-8"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeVerrekenenVerliesBox2JaarMinAcht"
                                                      id="nogTeVerrekenenVerliesBox2JaarMinAcht"
                                                      label="Nog te verr Box2 T-8"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="verrekendVerliesBox2JaarMinZeven"
                                                      id="verrekendVerliesBox2JaarMinZeven"
                                                      label="Verr. verlies Box2 T-7"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeVerrekenenVerliesBox2JaarMinZeven"
                                                      id="nogTeVerrekenenVerliesBox2JaarMinZeven"
                                                      label="Nog te verr Box2 T-7"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                </div>
                <div>
                    <snelstart-ui-number-form-control formControlName="verrekendVerliesBox2JaarMinZes"
                                                      id="verrekendVerliesBox2JaarMinZes"
                                                      label="Verr. verlies Box2 T-6"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeVerrekenenVerliesBox2JaarMinZes"
                                                      id="nogTeVerrekenenVerliesBox2JaarMinZes"
                                                      label="Nog te verr Box2 T-6"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="verrekendVerliesBox2JaarMinVijf"
                                                      id="verrekendVerliesBox2JaarMinVijf"
                                                      label="Verr. verlies Box2 T-5"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeVerrekenenVerliesBox2JaarMinVijf"
                                                      id="nogTeVerrekenenVerliesBox2JaarMinVijf"
                                                      label="Nog te verr Box2 T-5"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="verrekendVerliesBox2JaarMinVier"
                                                      id="verrekendVerliesBox2JaarMinVier"
                                                      label="Verr. verlies Box2 T-4"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeVerrekenenVerliesBox2JaarMinVier"
                                                      id="nogTeVerrekenenVerliesBox2JaarMinVier"
                                                      label="Nog te verr Box2 T-4"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                </div>
                <div>
                    <snelstart-ui-number-form-control formControlName="verrekendVerliesBox2JaarMinDrie"
                                                      id="verrekendVerliesBox2JaarMinDrie"
                                                      label="Verr. verlies Box2 T-3"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeVerrekenenVerliesBox2JaarMinDrie"
                                                      id="nogTeVerrekenenVerliesBox2JaarMinDrie"
                                                      label="Nog te verr Box2 T-3"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="verrekendVerliesBox2JaarMinTwee"
                                                      id="verrekendVerliesBox2JaarMinTwee"
                                                      label="Verr. verlies Box2 T-2"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeVerrekenenVerliesBox2JaarMinTwee"
                                                      id="nogTeVerrekenenVerliesBox2JaarMinTwee"
                                                      label="Nog te verr Box2 T-2"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="verrekendVerliesBox2JaarMinEen"
                                                      id="verrekendVerliesBox2JaarMinEen"
                                                      label="Verr. verlies Box2 T-1"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeVerrekenenVerliesBox2JaarMinEen"
                                                      id="nogTeVerrekenenVerliesBox2JaarMinEen"
                                                      label="Nog te verr Box2 T-1"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                </div>
                <div>
                    <snelstart-ui-number-form-control formControlName="verrekendeBuitenlandseBronheffing"
                                                      id="verrekendeBuitenlandseBronheffing"
                                                      label="Verr. buitenl. bronheffing"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="nogTeVerrekenenBuitenlandseBronheffing"
                                                      id="nogTeVerrekenenBuitenlandseBronheffing"
                                                      label="Nog te verr. buitenl. bronheffing"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                                      align="right"
                                                      prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                </div>
            </div>
        </div>
    </div>
</form>
